// extracted by mini-css-extract-plugin
module.exports = {"finance_box":"finance_box-2yAjIUsY"};